export default "__VITE_ASSET__d301aacc__"